<template>
    <f7-page
        name="We Care"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="We Care"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>We Care</f7-nav-title>
        </f7-navbar>

        <f7-block style="background: white; color: black; padding: 32px 16px">
            <p style="text-align: left">
                Because of the nature of Coral, we recognize that we ask you to entrust us with some of your most sensitive information. In order to earn that trust we have committed to adhere to the EU General Data Protection Regulation (GDPR) for all Coral users, regardless of location. This means that you have the right to see what information we have collected, download it and even delete it if you so wish.
                <br><br>
                We also take great care to minimize the risk of your information falling into the wrong hands. We will never sell your personally identifiable data and only work with the most trustworthy third party contractors. In addition, we don’t connect your email or other personally identifying information to your sensitive information in our content management system.
                <br><br>
                See our full legal privacy policy <f7-link href="/privacy">here</f7-link>
            </p>
        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api'],
    data () {
        return {};
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {}
};
</script>

<style lang="less" scoped>
.center {
    text-align: center;
}
</style>
